import classnames from 'classnames';
import React, { FC, MutableRefObject } from 'react';

import { hasContent } from '../../../../util/guards';
import { useFocus } from '../Selectors/useFocus';
import s from './ButtonLinkWrapper.scss';

type ButtonLinkWrapperProps = {
  link?: string;
  onClick?: () => void;
  className?: string;
  hasFocus?: boolean;
};

/**
 * Responsible for wrapping a button with an optional link, and applying border style within a grid.
 */
export const ButtonLinkWrapper: FC<ButtonLinkWrapperProps> = ({
  link,
  onClick,
  children,
  className,
  hasFocus = false,
  ...other
}) => {
  const commonProps = {
    onClick,
    className: classnames(s.buttonItem, className),
    ...other,
  };

  const ref = useFocus(hasFocus);

  if (hasContent(link)) {
    return (
      <a
        tabIndex={0}
        ref={ref as MutableRefObject<HTMLAnchorElement>}
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        {...commonProps}
      >
        {children}
      </a>
    );
  }

  return (
    <button tabIndex={0} ref={ref as MutableRefObject<HTMLButtonElement>} {...commonProps}>
      {children}
    </button>
  );
};
